
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 2a8 8 0 108 8 8 8 0 00-8-8zm0 14.643A6.643 6.643 0 1116.643 10 6.644 6.644 0 0110 16.643z"}}),_c('path',{attrs:{"d":"M11.994 6.512a3.096 3.096 0 00-3.986 0 2.434 2.434 0 00-.864 1.845v.136a.143.143 0 00.142.143h.858a.143.143 0 00.142-.143v-.136a1.593 1.593 0 011.715-1.428 1.593 1.593 0 011.714 1.428 1.445 1.445 0 01-1.002 1.298 1.996 1.996 0 00-.93.73 2.044 2.044 0 00-.356 1.16v.384a.143.143 0 00.143.142h.857a.143.143 0 00.143-.143v-.405a.863.863 0 01.552-.8 2.578 2.578 0 001.734-2.366 2.427 2.427 0 00-.862-1.845zM9.286 13.93a.714.714 0 10.21-.506.715.715 0 00-.21.505z"}})])
          )
        }
      }
    